var _defs, _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkbox-unchecked_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1161.11 1161.11"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".checkbox-unchecked_svg__cls-1{fill:#35a4dd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M580.56 30C277 30 30 277 30 580.56s247 550.55 550.56 550.55 550.55-247 550.55-550.55S884.13 30 580.56 30z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 580.56,
    cy: 777.78,
    r: 32.6,
    transform: "rotate(-22.5 580.546 777.775)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M580.56 306.63c-81.26 0-147.37 66.11-147.37 147.37a33.09 33.09 0 0066.18 0 81.19 81.19 0 1181.19 81.18 33.13 33.13 0 00-33.09 33.09v95.23a33.09 33.09 0 0066.18 0v-65.83l3.75-1a148.42 148.42 0 0079.07-51.8A146.66 146.66 0 00727.92 454c0-81.26-66.11-147.37-147.36-147.37z"
  })));
}

export default SvgCheckboxUnchecked;